import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M994.577974 1436.35559C861.21303 1436.35559 752.755772 1544.81285 752.755772 1678.1778 752.755772 1811.54274 861.21303 1920 994.577974 1920 1127.94292 1920 1236.40018 1811.54274 1236.40018 1678.1778 1236.40018 1544.81285 1127.94292 1436.35559 994.577974 1436.35559L994.577974 1436.35559zM1165.06263 1315.44449L1310.15595 0 679 0 824.093322 1315.44449z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconWarningBorderlessSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconWarningBorderlessSolid, _Component);

  var _super = _createSuper(IconWarningBorderlessSolid);

  function IconWarningBorderlessSolid() {
    _classCallCheck(this, IconWarningBorderlessSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconWarningBorderlessSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconWarningBorderless",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconWarningBorderlessSolid.displayName = "IconWarningBorderlessSolid";
  return IconWarningBorderlessSolid;
}(Component);

IconWarningBorderlessSolid.glyphName = 'warning-borderless';
IconWarningBorderlessSolid.variant = 'Solid';
IconWarningBorderlessSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconWarningBorderlessSolid;
export { IconWarningBorderlessSolid };